import DLink from "./DLink";
import CentralLink from "./CentralLink";

export default function Navbar( {projects, children} ) {
    return (
        <>
            <div id="navbar" className="navbar">
                <DLink className="navbar-e navbar-top-e" to="/projects/">Projects</DLink>
                <div className="navbar-e navbar-center navbar-title"><CentralLink projects={projects} className="navbar-e navbar-title" to="/">Vliegen die chocolade eten schijten bruine stippen</CentralLink></div>
                <DLink className="navbar-e navbar-top-e" to="/about/">About</DLink>
            </div>
            {children}
            <div id="navbar-bottom" className="navbar">
                <DLink className="navbar-e" to="/projects/">Projects</DLink>
                <DLink className="navbar-e" to="/about/">About</DLink>
            </div>
        </>
    )
}